// Versione "lite" (palette awrabet/koba) dei template tournament usati dalle righe evento
// della home di gojjobet. Stessa struttura di jamibet/mobile-templates/tournament.jsx, colori gojjo-lite.
import { Fragment } from "preact";

import formatOdd from "../../../services/odds-format";
import * as I from "../../jamibet/utils/icons";

export function TournamentDatesHeader({children}) {
	return <div class="fn-tournament-dates-header h-6 w-full border-b border-gojjo-lite-300 bg-gojjo-lite-200 text-gojjo-lite-950">
		<div class="flex h-full w-full items-center justify-between">
			{children}
			<div class="hidden w-14 shrink-0 grow-0 text-center text-xs sm:block"></div>
		</div>
	</div>
}

export function TournamentDate({children}) {
	return <div class="min-w-0 grow px-2 text-xs truncate">{children}</div>
}
export function TournamentName({children}) {
	return <div class="min-w-0 grow text-sm truncate">{children}</div>
}

export function OutcomeNameHeader({children}) {
	return <div class="w-14 shrink-0 grow-0 text-center text-xs truncate">{children}</div>
}

export function MatchRow({children}) {
	return <div class="fn-event-row-mobile h-18 w-full overflow-x-auto scrollbar-hide border-t border-t-gojjo-lite-300 border-b border-b-gojjo-lite-300 bg-gojjo-lite-100 text-gojjo-lite-950">
		<div class="w-full-14 sm:w-full flex h-full items-stretch justify-between">
			{children}
		</div>
	</div>;
}

export function MatchInfo({children, ...props}) {
	return <div class="flex min-w-0 grow flex-col justify-between overflow-x-hidden overflow-y-hidden px-2 py-1 text-sm" {...props}>
		{children}
	</div>
}

export function StatsCell({children}) {
	return <div class="w-8 shrink-0 grow-0 text-xs flex items-center justify-start pl-1 pr-3 border-r border-gojjo-lite-300">{children}</div>
}
export function Teams({children}) {
	return <div>{children}</div>;
}
export function TeamWithScore({children}) {
	return <div class="flex items-center">{children}</div>
}
export function HomeTeamName({children}) {
	return <div class="fn-home-team-name truncate grow font-bold text-base">{children}</div>
}
export function AwayTeamName({children}) {
	return <div class="fn-home-team-name truncate grow font-bold text-base">{children}</div>
}
export function ScoreElement({children}) {
	return <div class="bg-gojjo-gold-lite-500 text-sm text-gojjo-lite-950 font-bold flex-none w-5 h-5 leading-none flex items-center justify-center">{children}</div>
}
export function MatchTime({children}) {
	return <div class="fn-start-time text-xs">{children}</div>
}

export function OddButtonCell({children}) {
	return <div class="w-14 shrink-0 grow-0 text-center text-xs border-r border-gojjo-lite-300">{children}</div>
}
export function OddButton({value, active, onClick, selected, useLock = false}) {
	if (selected)
		return <div
				   class="fn-odd-btn bg-gojjo-gold-lite-400 text-gojjo-lite-950 flex h-full w-full items-center justify-center text-base font-bold"
				   onClick={onClick}
				   >
			{!!value ? formatOdd(value) : (!useLock ? '-' : <>
				<I.LockIcon class="h-3" />
			</>)}
		</div>
	return <div
			   class="fn-odd-btn text-gojjo-gold-lite-600 flex h-full w-full items-center justify-center text-base font-bold"
			   onClick={onClick}>
		{!!value ? formatOdd(value) : (!useLock ? '-' : <>
			<I.LockIcon class="h-3" />
		</>)}
	</div>
}
export function StarCell({children, selected, onClick}) {
	return <div class="w-14 shrink-0 grow-0 text-center text-xs flex items-center justify-center" onClick={onClick}>{children}</div>
}

export function FakeSeparator() {
	return <div class="fn-fake-rail h-2 w-full border-b border-gojjo-lite-300 bg-gojjo-lite-200"></div>;
}
